import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import NumberInput from "../../components/NumberInput";

export default function OTPVerification() {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [isDisabled, setIsDisabled] = useState(true);
  const inputsRef = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/stock");
    }
  });

  useEffect(() => {
    inputsRef.current[0].focus();
  }, []);

  const handleChange = (element, index) => {
    let value = element.value;

    if (isNaN(value)) return;

    if (value.length > 1) {
      value = value.slice(-1); // Prendre le dernier chiffre saisi
    }

    setOtp([...otp.map((d, idx) => (idx === index ? value : d))]);

    // Focus next input
    if (value !== "" && index < otp.length - 1) {
      inputsRef.current[index + 1].removeAttribute("disabled");
      inputsRef.current[index + 1].focus();
    }
    checkStat();
  };

  const handleKeyUp = (e, index) => {
    if (e.key === "Backspace") {
      setOtp([...otp.map((d, idx) => (idx === index ? "" : d))]);
      if (index > 0) {
        inputsRef.current[index].setAttribute("disabled", true);
        inputsRef.current[index - 1].focus();
      }
    }
    checkStat();
  };

  const handlePaste = (e) => {
    const data = e.clipboardData.getData("text").split("");
    if (data.length === otp.length) {
      setOtp(data);
      data.forEach((value, index) => {
        inputsRef.current[index].value = value;
        if (index < data.length - 1) {
          inputsRef.current[index + 1].removeAttribute("disabled");
        }
      });
      inputsRef.current[data.length - 1].focus();
    }
  };

  const checkStat = () => {
    const allFilled = otp.every((value) => value !== "");
    setIsDisabled(!allFilled);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success("OTP vérifié avec succès");
    // Ici, vous pouvez ajouter la logique pour vérifier le code OTP
    navigate("/stock");
  };

  return (
    <div className="bg-white rounded-lg overflow-hidden px-8 py-16 shadow-md shadow-[#00000015] cont flex items-center justify-center flex-col gap-4 border border-[#00000015] max-w-md max-sm:max-w-sm m-auto my-16">
      <ToastContainer />
      <header className="h-16 w-16 bg-amber-500 text-white rounded-full flex items-center justify-center text-4xl">
        <svg
          className="w-10 h-10"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            fillRule="evenodd"
            d="M11.644 3.066a1 1 0 0 1 .712 0l7 2.666A1 1 0 0 1 20 6.68a17.694 17.694 0 0 1-2.023 7.98 17.406 17.406 0 0 1-5.402 6.158 1 1 0 0 1-1.15 0 17.405 17.405 0 0 1-5.403-6.157A17.695 17.695 0 0 1 4 6.68a1 1 0 0 1 .644-.949l7-2.666Zm4.014 7.187a1 1 0 0 0-1.316-1.506l-3.296 2.884-.839-.838a1 1 0 0 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.366.046l4-3.5Z"
            clipRule="evenodd"
          />
        </svg>
      </header>
      <h1 className="text-xl font-medium">Entrer le code à 6 chiffres</h1>
      <div id="value"></div>
      <form
        onSubmit={handleSubmit}
        className="flex items-center justify-center flex-col gap-4"
      >
        <div className="input-field flex items-center justify-center gap-2">
          {otp.map((data, index) => (
            <NumberInput
              key={index}
              type="text"
              maxLength="1"
              value={data}
              onChange={(e) => handleChange(e.target, index)}
              onKeyUp={(e) => handleKeyUp(e, index)}
              onPaste={handlePaste}
              ref={(el) => (inputsRef.current[index] = el)}
              className="w-12 h-12 text-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500"
            />
          ))}
        </div>
        <input
          type="submit"
          value="S'authentifier"
          className={`bg-amber-400 text-white p-2 w-full rounded-lg cursor-pointer hover:scale-105 ${
            isDisabled ? "pointer-events-none" : ""
          }`}
          disabled={isDisabled}
        />
      </form>
    </div>
  );
}
